import { render, staticRenderFns } from "./KinderverwaltungScanAPI.vue?vue&type=template&id=a00b6dc6&"
import script from "./KinderverwaltungScanAPI.vue?vue&type=script&lang=js&"
export * from "./KinderverwaltungScanAPI.vue?vue&type=script&lang=js&"
import style0 from "./KinderverwaltungScanAPI.vue?vue&type=style&index=0&id=a00b6dc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCheckbox,VDialog,VIcon,VProgressLinear,VTextField})
